import styled from '@emotion/styled'
import { stylesIf } from 'utils/styles'
import LogicGateSymbol from '../LogicGateSymbol/LogicGateSymbol'

export const StyledQueryOperators = styled.div`
  pointer-events: none;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  z-index: 2;
  margin: 0 auto 3.15px;
`
export const StyledLogicGateSymbol = styled(LogicGateSymbol)((props) => {
  const { type } = props

  const finalGateStyle = `
    pointer-events: none;
    width: 45px;
  `
  return `
  position: relative;
  ${stylesIf(type === 'xyz', finalGateStyle)}
  `
})
